<div class="row">
  <div class="col">
    <label class="mb-2 d-block">{{ field.label }}</label>

    <div *ngFor="let option of field.options" class="form-check">
      <mat-checkbox
        [checked]="control.value?.includes(option.value)"
        (change)="onCheckboxChange($event, option)"
        class="d-block mb-1"
      >
        {{ option.value }}
      </mat-checkbox>
    </div>

    <mat-error
      *ngIf="field.isRequired && (!control.value || control.value.length === 0)"
    >
      {{ field.label }} is required
    </mat-error>
  </div>
</div>
